import React, { useEffect } from 'react'
import EstimateItem from './estimateItem'
import { fetchEstimates } from 'application/actions/estimatesActions'
import { connect, useSelector } from 'react-redux'
import withLocation from '../../withLocation'
import Carousel from 'react-multi-carousel'
import BannerMainImageSection from '../../bannerMainImageSection'
import Layout from 'application/layout'
import { Container } from 'react-bootstrap'
import {
  applicationRoles,
  httpVerbConstants,
} from 'application/constants/actionTypes'
import { fetchEstimates as consultantFetchEstimates } from 'application/actions/consultantEstimatesActions'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
} from 'application/helpers'
import useWindowSize from 'application/helpers/useWindowSize'
import useEleListHeight from 'application/helpers/useEleListHeight'
import { TermsAndConditions } from '../../termsAndConditions'
import {
  EstimateItemWrapper,
  EstimateComparePageStyled
} from './indexStyled'
import * as E from './estimateItemStyled'
import { CheckBoxStyled } from 'application/components/styledComponents/checkBoxStyled/checkBoxStyled'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import { Icon as RemServIcon } from 'RemServ/icons'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Image as RemServImage } from 'RemServ/images'
import globals from 'application/constants/globals'

export const EstimatesScreen = ({
  accessToken,
  isAuthenticated,
  opportunityId,
  payFrequency,
  dispatch,
  estimatesExist,
  nlFeePerAnnumIncGST,
  financierEstablishmentFee,
  spFeePerAnnumIncGST,
  financierFeePerPay
}) => {
  let headers = { accessToken: accessToken }
  const userEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:estimates' },
      },
    })
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'compare estimates',
          label: 'compare estimates',
        },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:estimates' },
        },
      })
    }
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:consultant:estimates' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:consultant:estimates' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'compare estimates',
          label: 'compare estimates',
        },
      },
    })
  }
  const customEvents = () => {
    checkConsultant() ? consultantEvents() : userEvents()
    toggleHide()
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      if (estimatesExist) {
        customEvents()
      } else {
        dispatch(
          checkConsultant()
            ? consultantFetchEstimates(
                opportunityId,
                headers,
                httpVerbConstants.HTTP_GET
              )
            : fetchEstimates(opportunityId)
        )
        customEvents()
      }
    }
  }, [])
  const [isHidden, setIsHidden] = React.useState(true)
  const toggleHide = () => {
    updateCurrentLimit(isHidden)
    setIsHidden(!isHidden)
  }
  const headerHeight = useEleListHeight('.estimate-item__main--heading')
  const vehicleDescHeight = useEleListHeight('.estimate-item__description')
  let estimates = useSelector((state) => state.estimates.estimates)
  
  let user = useSelector((state) => state.user)
  const { firstName, employer } = user
  let proposalState = useSelector((state) =>
    state.proposal && state.proposal.proposal ? state.proposal.proposal : null
  )

  const isInactiveSparta = (vehicle) => {
    let invalid = false
    if (
      vehicle.id &&
      vehicle.shadowPR &&
      vehicle.spartaDetail &&
      !vehicle.spartaDetail.offerActive
    )
      invalid = true
    return invalid
  }
  estimates.sort((a, b) => new Date(b.updatedOn) - new Date(a.updatedOn))
  estimates.sort((a, b) => {
    let aInvalid
    let aIsProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == a.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    if (proposalState && proposalState.isValid && proposalState.quoteId) {
      aInvalid = a.id != proposalState.quoteId
    } else if (!a.isValid) {
      aInvalid = true
    } else {
      aInvalid = false
    }
    if (!aInvalid && isInactiveSparta(a.vehicle) && !aIsProposalAcceptedQuote)
      aInvalid = true

    let bIsProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == b.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    let bInvalid
    if (proposalState && proposalState.isValid && proposalState.quoteId) {
      bInvalid = b.id != proposalState.quoteId
    } else if (!b.isValid) {
      bInvalid = true
    } else {
      bInvalid = false
    }
    if (!bInvalid && isInactiveSparta(b.vehicle) && !bIsProposalAcceptedQuote)
      bInvalid = true

    return aInvalid === bInvalid && bInvalid ? 0 : bInvalid ? -1 : 1
  })

  const hasNonIntegralYearTerm = estimates.some((estimate) => {
    return estimate.leaseTerm % 12 !== 0
  })

  const estimateItems = estimates.map((estimate, i) => (
    <EstimateItemWrapper key={estimate.id}>
      <EstimateItem
        estimate={estimate}
        proposal={proposalState}
        applicationRole={applicationRoles.CUSTOMER}
        isConsultant={checkConsultant()}
        headerHeight={headerHeight}
        vehicleDescHeight={vehicleDescHeight}
        userEmployer={employer}
        isHidden={isHidden}
        index={i}
        hasNonIntegralYearTerm={hasNonIntegralYearTerm}
      ></EstimateItem>
    </EstimateItemWrapper>
  ))
  
  const windowSize = useWindowSize()
  const size = windowSize.width
  const controlShow = () => {
    if (estimateItems && estimateItems.length === 1 && size > 0) {
      return false
    } else if (estimateItems && estimateItems.length === 2 && size > 768) {
      return false
    } else if (estimateItems && estimateItems.length === 3 && size > 1200) {
      return false
    } else {
      return true
    }
  }

  let [currentLimit, setCurrentLimit] = React.useState(estimates.length)
  const updateCurrentLimit = (showAll) => {
    if (!showAll) {
      setCurrentLimit((currentLimit = estimateItems.length - count))
    } else {
      setCurrentLimit((currentLimit = estimateItems.length))
    }
  }
  let count = 0
  if (estimates.length > 0 && currentLimit == 0) {
    updateCurrentLimit(true)
  }
  estimates.map((estimate) => {
    let invalid
    let isProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == estimate.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    if (
      proposalState &&
      proposalState.isValid === false &&
      proposalState.quoteId == estimate.id
    ) {
      // Marks the estimate as inactive if proposal is invalid
      invalid = true
    } else if (
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId
    ) {
      invalid = estimate.id != proposalState.quoteId
    } else if (!estimate.isValid) {
      invalid = true
    } else {
      invalid = false
    }
    if (
      !invalid &&
      isInactiveSparta(estimate.vehicle) &&
      !isProposalAcceptedQuote
    )
      invalid = true

    if (invalid) {
      count++
    }
  })

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest
    return (
      // remember to give it position:absolute
      <Container>
        <E.ListContainer>
          {count > 0 ? (
            <E.HideBox
              onClick={() => {
                toggleHide()
                goToSlide(0)
              }}
              id="estimatecompareindex.hidebox"
            >
              <CheckBoxStyled active={isHidden} />
              <div>&nbsp;Hide Inactive ({count})</div>
            </E.HideBox>
          ) : (
            <div></div>
          )}

          <E.CarousalNav>
            <E.NavCount id="estimatecompareindex.estimatecount">
              {' '}
              {size > 768
                ? estimates.length > 1
                  ? `Showing ${currentSlide + 1} - ${
                      currentSlide + 3 >= estimates.length
                        ? estimates.length
                        : currentSlide + 3
                    } of 
            ${estimates.length}`
                  : `Showing ${currentSlide + 1} of ${estimates.length}`
                : `${currentSlide + 1} of  ${estimates.length}`}
            </E.NavCount>
            <E.NavButton
              onClick={() => previous()}
              disabled={currentSlide == 0}
              id="estimatecompareindex.leftarrow"
            >
              {globals.isBrandMX && <MaxxiaIcon iconType="ArrowLeft" />}
              {globals.isBrandRS && <RemServIcon iconType="ArrowLeft" />}
            </E.NavButton>
            <E.NavButton
              onClick={() => next()}
              disabled={
                size > 768
                  ? currentSlide + 3 >= currentLimit
                  : currentSlide >= currentLimit - 1
              }
              id="estimatecompareindex.rightarrow"
            >
              {globals.isBrandMX && <MaxxiaIcon iconType="ArrowRight" />}
              {globals.isBrandRS && <RemServIcon iconType="ArrowRight" />}
            </E.NavButton>
          </E.CarousalNav>
        </E.ListContainer>
      </Container>
    )
  }

  return (
    <Layout>
      <EstimateComparePageStyled>
        <div id="page" className="compare-estimate-page">
          <BannerMainImageSection
            id="estimatetobereviewedstage.bannermainsection"
            isLeftAlign={true}
            imageName={globals.isBrandMX ? 'Banner2' : ''}
          >
            {globals.isBrandRS && (
              <E.WhiteHeading>REMSERV LEASE</E.WhiteHeading>
            )}
            {globals.isBrandMX
              ? 'Welcome to your Maxxia estimate ' + firstName
              : `Welcome to your RemServ estimate`}
            <E.BannerText id="estimatecompareindex.bannercontent">
              Alright {firstName}, time to crunch the numbers and discover your
              estimated savings. Compare an overview of your options below, or
              get stuck into the nitty gritty of each lease by tapping ‘View
              Details’.
            </E.BannerText>
          </BannerMainImageSection>

          <Container>
            <E.DisclaimerDiv>
              All estimates presented are for illustrative purposes only and are
              only current as at the date generated. Estimates shown may not be
              valid after the generation date.
            </E.DisclaimerDiv>
          </Container>

          {estimateItems && estimateItems.length === 0 && (
            <Container>
              <div className="mt-5 mb-5 d-flex justify-content-center">
                {globals.isBrandMX && (
                  <MaxxiaImage imageName={'Loader'} alt="" />
                )}
                {globals.isBrandRS && (
                  <RemServImage imageName={'Loader'} alt="" />
                )}
              </div>
            </Container>
          )}
          <div
            className={
              estimateItems && estimateItems.length === 3
                ? 'navigators estimate-list'
                : 'estimate-list'
            }
          >
            <Carousel
              arrows={false}
              renderButtonGroupOutside={true}
              customButtonGroup={<ButtonGroup />}
              additionalTransfrom={0}
              autoPlaySpeed={3000}
              centerMode={false}
              className=""
              containerClass="container"
              dotListClass=""
              draggable={controlShow()}
              swipeable={controlShow()}
              focusOnSelect={false}
              infinite={false}
              itemClass=""
              keyBoardControl
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1201,
                  },
                  items: 3,
                  partialVisibilityGutter: 0,
                },
                mobile: {
                  breakpoint: {
                    max: 768,
                    min: 0,
                  },
                  items: 1,
                  partialVisibilityGutter: 0,
                },
                tablet: {
                  breakpoint: {
                    max: 1200,
                    min: 769,
                  },
                  items: 2,
                  partialVisibilityGutter: 0,
                },
              }}
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
            >
              {estimateItems}
            </Carousel>
          </div>
        </div>
        {global.config.isBrandMX && (
          <TermsAndConditions
            fbtMethod={'ECM'}
            payFrequency={payFrequency}
            nlFeePerAnnumIncGST={nlFeePerAnnumIncGST}
            financierEstablishmentFee={financierEstablishmentFee}
            spFeePerAnnumIncGST={spFeePerAnnumIncGST}
            financierFeePerPay={financierFeePerPay}
          />
        )}
      </EstimateComparePageStyled>
    </Layout>
  )
}

function mapStateToProps(state, ownProps) {
  const { firstName: userFirstName, employer: { payFrequency } = {} } =
    state.user

  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = state.authentication.opportunityId
  const accessToken = state.auth.accessToken
  const estimatesExist = state.estimates.estimates.length !== 0
  let nlFeePerAnnumIncGST = 275
  let financierEstablishmentFee = 431.82
  let spFeePerAnnumIncGST = 325
  let financierFeePerPay = 0

  if (estimatesExist) {
    if (state.estimates.estimates[0].nlFeePerAnnumIncGST !== null)
      nlFeePerAnnumIncGST = state.estimates.estimates[0].nlFeePerAnnumIncGST
    if (state.estimates.estimates[0].financierEstablishmentFee !== null)
      financierEstablishmentFee =
        state.estimates.estimates[0].financierEstablishmentFee
    if (state.estimates.estimates[0].spFeePerAnnumIncGST !== null)
      spFeePerAnnumIncGST = state.estimates.estimates[0].spFeePerAnnumIncGST
    if (state.estimates.estimates[0].financierFeePerPay !== null)
      financierFeePerPay = state.estimates.estimates[0].financierFeePerPay
  }

  return {
    isAuthenticated,
    opportunityId,
    payFrequency,
    accessToken,
    estimatesExist,
    nlFeePerAnnumIncGST,
    financierEstablishmentFee,
    spFeePerAnnumIncGST,
    financierFeePerPay
  }
}

export default connect(mapStateToProps)(withLocation(EstimatesScreen))
